var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.canDisplayProgram)?_c('div',{attrs:{"data-cy":"program-content"}},[_c('div',[_c('ProgramState',{attrs:{"program":this.getProgram}})],1)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }